import * as React from "react";
import { useState, useEffect } from "react";
import ListaVerificacionService from "../../services/listaVerificacionService";
import {
  DetailsList,
  DetailsListLayoutMode,
  Selection,
  IColumn,
  SelectionMode,
} from "@fluentui/react/lib/DetailsList";
import { Text } from "@fluentui/react/lib/Text";
import { useNavigate } from 'react-router-dom';
import {
  mergeStyleSets,
  getTheme,
  concatStyleSets,
} from "@fluentui/react/lib/Styling";
import {
  CommandBar,
  IStyleFunctionOrObject,
  ComboBox,
  IComboBox,
  IComboBoxOption,
  ICommandBarItemProps,
  IContextualMenuItemStyles,
  ICommandBarStyleProps,
  ICommandBarStyles,
  TooltipHost,
  Stack,
} from "@fluentui/react";
import {
  CommandBarButton,
  IButtonProps,
  IButtonStyles,
} from "@fluentui/react/lib/Button";

import { Panel, PanelType } from "@fluentui/react/lib/Panel";
import { useBoolean } from "@fluentui/react-hooks";
import { DefaultButton, PrimaryButton } from "@fluentui/react/lib/Button";
import { Icon } from "@fluentui/react/lib/Icon";
import { ProgressIndicator } from "@fluentui/react/lib/ProgressIndicator";
import { IListaEquipoModelo, IOptionPersona, ListaPersona } from "../../Interfaces/IListaVerificacion";
import { IObjectWithKey, memoizeFunction } from "@fluentui/react/lib/Utilities";
import { ISearch } from "../../Interfaces/base/IBase";
import { IPersona } from "../../Interfaces/IPersona";
import { Dialog, DialogType, DialogFooter } from "@fluentui/react/lib/Dialog";
import themeBase from "../../utils/theme/themeBase";
import HeaderGeneric from "../../components/generic/headerGeneric";
import HeaderTable from "../../components/generic/HeaderTable";
import { TableBase } from "../../components/Table/TableBase";
import IconHelper from "../../utils/helpers/iconHelper";
import { Fecha } from "../../components/elements/Fecha";
import { ConfigHelper } from "../../utils/helpers/configHelper";
interface formModel {
  personaId: string,
  equipoModeloId: string,
}
const INITIAL_MODULE = {
  personaId: '',
  equipoModeloId: '',
}

const classNames = mergeStyleSets({
  fileIconHeaderIcon: {
    padding: 0,
    fontSize: '16px',
  },
  iconFont: {
    padding: 0,
    fontSize: "16px",
    marginRight: 5,
    color: '#0078d4'
  },
  fileIconCell: {
    textAlign: 'center',
    selectors: {
      '&:before': {
        content: '.',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%',
        width: '0px',
        visibility: 'hidden',
      },
    },
  },
  fileIconImg: {
    verticalAlign: 'middle',
    maxHeight: '16px',
    maxWidth: '16px',
  },
  controlWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  exampleToggle: {
    display: 'inline-block',
    marginBottom: '10px',
    marginRight: '30px',
  },
  selectionDetails: {
    marginBottom: '20px',
  },
  contenedor: {
    width: '100%',
  },

});

function ListarEquipoModelo() {
  const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
  const [hideDialogSuccess, { toggle: toggleHideDialogSuccess }] =
    useBoolean(true);
  const [hideDialogError, { toggle: toggleHideDialogError }] = useBoolean(true);
  const data: IListaEquipoModelo[] = [];
  const autorizacion: ListaPersona[] = [];
  const [items, setItems] = useState(data);
  const [itemsP, setItemsP] = useState(autorizacion);
  const itemArray: IObjectWithKey[] = [];
  const [openPanel, setOpenPanel] = useState(false);
  // const [itemSeleccionados, setItemSeleccionados] = useState(itemArray);
  // const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] =
  // useBoolean(false);
  let navigate = useNavigate();

  const [model, setmodel] = useState<formModel>(INITIAL_MODULE);

  const _columnsP: IColumn[] = [
    {
      key: "persona",
      name: "Persona",
      fieldName: "persona",
      minWidth: 200,
      maxWidth: 300,
      isResizable: true,
    },
    {
      key: "opciones",
      name: "Opciones",
      fieldName: "opciones",
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
      onRender: (item: ListaPersona) => (
        <>
          <TooltipHost content={`Agregar Personas`}>
            <Icon iconName='Trash'
              style={{ cursor: 'pointer', color: "red" }}
              className={classNames.iconFont}
              onClick={() => {
                let body: any = {};
                body.personaId = item.personaId;
                body.equipoModeloId = item.equipoModeloId;
                console.log("DDDDDD", item);
                ListaVerificacionService.eliminarAutorizacion(body)
                  .then((response: any) => {
                    if (response.status == 200) {
                      alert('Se eliminó correctamente');
                      let query: any = {};
                      query.EquipoModeloId = model.equipoModeloId;
                      ListaVerificacionService.listarAutorizaciones(query).then((x => {
                        setItemsP(x.data.data);
                      }));
                    }
                  })
                  .catch((e: Error) => {
                    console.log(e);
                  });
              }}

            />
          </TooltipHost>
        </>
      ),
    },
  ];
  const _columns: IColumn[] = [
    {
      key: "equipo",
      name: "Equipo",
      fieldName: "equipo",
      minWidth: 200,
      maxWidth: 300,
      isResizable: true,
    },
    {
      key: "tipoEquipo",
      name: "Tipo Equipo",
      fieldName: "tipoEquipo",
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "fecha",
      name: "Fecha",
      fieldName: "fecha",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
      // onRender: (item: any) => (
      //   <Fecha value={item.fecha} />
      // )
    },
    {
      key: "opciones",
      name: "Opciones",
      fieldName: "opciones",
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
      onRender: (item: IListaEquipoModelo) => (
        <>
          <TooltipHost content={`Asignar Personas`}>
            <Icon iconName='ContactList'
              style={{ cursor: 'pointer' }}
              className={classNames.iconFont}
              onClick={() => {

                navigate(`${item.equipoModeloId}`)

                // setOpenPanel(true);
                let query: any = {};
                query.EquipoModeloId = item.equipoModeloId;

                setmodel({ ...model, equipoModeloId: item.equipoModeloId });
                // model.equipoModeloId = item.equipoModeloId;
                ListaVerificacionService.listarAutorizaciones(query).then((x => {
                  console.log("DATA", x);
                  setItemsP(x.data.data);
                }));
              }}

            />
          </TooltipHost>
        </>
      ),
    },
  ];

  // const _selection = new Selection({
  //   onSelectionChanged: () => {
  //     setItemSeleccionados(_selection.getSelection());
  //   },
  // });

  //   function loadTabla(body: any) {
  //     ListaVerificacionService.getTabla(body).then((x) => {
  //         console.log("Cargar tabla");
  //         console.log(x);
  //     //   setItems(x.data.items);
  //     });
  //   }
  const [filterPersona, setFilterPersona] = useState<ISearch>({ search: null });

  function LoadData(query: any) {
    setItems([])
    query.skip = 0;
    query.take = 50;
    ListaVerificacionService.listarEquipoModelos(query).then((x => {
      console.log(x);
      setItems(x.data.data);
    }));
    //   setItems()
  }

  useEffect(() => {
    LoadData({ SoloCriticas: true });

    console.log()
  }, []);

  useEffect(() => {
    if (filterPersona.search != null) {
      dataPersona();
    }
  }, [filterPersona]);

  const theme = getTheme();

  const _items: ICommandBarItemProps[] = [
    // {
    //   key: "revisar",
    //   text: "Revisar",
    //   iconProps: { iconName: "CheckMark" },
    //   onClick: () => {
    //     if (itemSeleccionados.length > 0) {
    //       setOpenPanel(true);
    //       //traer detalle si es uno caso contrario listar de la selección:
    //       if (itemSeleccionados.length === 1) {
    //         // var valor = itemSeleccionados[0] as IItemListaVerificacion;
    //         //itemRevision.listaVerificacionId = valor.listaVerificacionId;
    //         // setItemRevision(valor);
    //         // setItemsRevision(dataRevision);
    //         // ListaVerificacionService.getDetalle(valor.listaVerificacionId).then(
    //         //   (x) => {
    //         //     setItemDetalleListaVerificacion(x.data);
    //         //   }
    //         // );
    //         console.log("Un Elemento Seleccionado");
    //       } else {
    //         // var valores = itemSeleccionados as IItemListaVerificacion[];
    //         // setItemRevision(itemDataRevision);
    //         // setItemsRevision(valores);
    //         // setItemDetalleListaVerificacion(detalleListaVerificacion);
    //         console.log("Varios elementos seleccionados");
    //       }
    //     } else {
    //     //   setItemRevision(itemDataRevision);
    //     //   setItemsRevision(dataRevision);
    //     console.log("No hay ningún elemento");
    //     }
    //   },
    // },
    {
      ...IconHelper.ICON_RELOAD,
      onClick: (arg) => LoadData({ SoloCriticas: true })
    },
  ];
  const _farItems: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_BACK,
      onClick: () => navigate(`${ConfigHelper.urlBase()}/iperc/configuraciones`),
      // onClick: () => navigate('/ssoma/iperc/configuraciones'),
    },
  ];

  const buttonStyles = { root: { marginRight: 8 } };
  const onRenderFooterContent = React.useCallback(
    () => (
      <div>
        <PrimaryButton
          onClick={() => {
            toggleHideDialog();
            // setOpenPanel(false);
            let mod: any = { EquipoModeloId: '', personaId: [] };
            mod.EquipoModeloId = model.equipoModeloId;
            mod.personaId.push(model.personaId)

            ListaVerificacionService.crearAutorizacion(mod)
              .then((x) => {
                //setItems(x.data.items);
                toggleHideDialog();
                toggleHideDialogSuccess();
                //actualizar la grilla
                let query: any = {};
                query.EquipoModeloId = model.equipoModeloId;
                ListaVerificacionService.listarAutorizaciones(query).then((x => {
                  setItemsP(x.data.data);
                }));
              })
              .catch((error) => {
                toggleHideDialog();
                toggleHideDialogError();
                let query: any = {};
                query.EquipoModeloId = model.equipoModeloId;
                ListaVerificacionService.listarAutorizaciones(query).then((x => {
                  setItemsP(x.data.data);
                }));
              });
          }}
          styles={buttonStyles}
        >
          Revisar
        </PrimaryButton>
        <DefaultButton onClick={() => {
          setOpenPanel(false);
          setItemsP([]);
        }}>
          Cancelar
        </DefaultButton>
      </div>
    ),
    [model]
  );

  const itemStyles: Partial<IContextualMenuItemStyles> = {
    label: { fontSize: 13 },
    icon: { color: theme.palette.blue },
    iconHovered: { color: theme.palette.blueDark },
  };

  const getCommandBarButtonStyles = memoizeFunction(
    (
      originalStyles: IButtonStyles | undefined
    ): Partial<IContextualMenuItemStyles> => {
      if (!originalStyles) {
        return itemStyles;
      }

      return concatStyleSets(originalStyles, itemStyles);
    }
  );

  const CustomButton: React.FunctionComponent<IButtonProps> = (props) => {
    // const buttonOnMouseClick = () => alert(`${props.text} clicked`);
    // eslint-disable-next-line react/jsx-no-bind
    return (
      <CommandBarButton
        {...props}
        //onClick={buttonOnMouseClick}
        styles={getCommandBarButtonStyles(props.styles)}
      />
    );
  };

  const commadStyles: IStyleFunctionOrObject<ICommandBarStyleProps, ICommandBarStyles> = {
    root: {
      padding: 0,
      margin: 0,
    },
  };

  const comboBoxRef = React.useRef<IComboBox>(null);
  const [persona, setPersona] = useState<IOptionPersona[]>([]);

  const _openOptionPersona = React.useCallback(() => comboBoxRef.current?.focus(true), []);



  const _onUpPersona = (ev?: React.KeyboardEvent<IComboBox>) => {
    _openOptionPersona();

    let { value } = ev?.target as HTMLInputElement;
    setFilterPersona({
      ...filterPersona,
      search: value,
    });
  }

  const _onChangePersona = (event: React.FormEvent<IComboBox>, option?: IComboBoxOption, index?: number, value?: string) => {
    if (event != undefined) {
      if (option != undefined) {
        // _onInfoPersona(option.key.toString());
        console.log("Esto tiene las opciones del combo", option);
        setmodel({
          ...model,
          personaId: option.key.toString(),
        })
      }
    }
  }

  const dataPersona = () => {
    ListaVerificacionService.personaByCustomer(filterPersona)
      .then(res => {
        /* v2 persona */
        let d: IPersona[] = res.data.data;
        let t: IOptionPersona[] = d.map(x => {
          return ({
            key: x.id,
            text: `${x.nroDOI} | ${x.persona}`,
            foto: x.foto,
            doi: x.nroDOI,
            puesto: x.puesto,
          });
        });

        setPersona(t);
      })
      .catch((e: Error) => {
        alert(e.message);
      });;
  }

  return (
    // style={{
    //   display: "block",
    //   flexWrap: "wrap",
    //   width: "100%",
    //   marginTop: 5,
    // }}

    <div className="ms-Grid-col ms-md12 ms-lg12" style={{ padding: "0.625rem" }}>

      <HeaderTable iconName="DashboardAdd" title="Equipos" subTitle="Asignar Personal" />
      <br />
      <Stack>
        <TableBase
          leftBar={_items}
          rigthBar={_farItems}
          data={items}
          column={_columns}
          isLoading={false}
          getPageSize={(arg) => { }}
          layout={DetailsListLayoutMode.justified}
        // pagination={pagIngreso}
        />
      </Stack>
      {/* <div className="ms-Grid-col ms-sm12 ms-lg12">
        <CommandBar
          buttonAs={CustomButton}
          items={_items}
          //overflowItems={_overflowItems}
          farItems={_farItems}
          ariaLabel="Use left and right arrow keys to navigate between commands"
          styles={themeBase.commadStyles}
        />
      </div>
      <div className="ms-Grid-col ms-sm12 ms-lg12">
        <DetailsList
          items={items}
          compact={true}
          columns={_columns}
          selectionMode={SelectionMode.none}
          setKey="single"
          layoutMode={DetailsListLayoutMode.fixedColumns}
          isHeaderVisible={true}
          selectionPreservedOnEmptyClick={true}
          enterModalSelectionOnTouch={true}
          ariaLabelForSelectionColumn="Toggle selection"
          ariaLabelForSelectAllCheckbox="Toggle selection for all items"
          checkButtonAriaLabel="select row"
        // styles={_onRenderHeader}
        // onRenderRow={_onRenderRow}
        />
      </div> */}

      <Panel
        isOpen={openPanel}
        onDismiss={() => setOpenPanel(false)}
        type={PanelType.medium}
        closeButtonAriaLabel="Close"
        headerText="Revision de Checklist"
        onRenderFooterContent={onRenderFooterContent}
        isFooterAtBottom={true}
      >
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <ComboBox
                componentRef={comboBoxRef}
                label="Persona"
                allowFreeform
                autoComplete='off'
                useComboBoxAsMenuWidth
                calloutProps={{ directionalHintFixed: true }}
                options={persona}
                onKeyUp={_onUpPersona}
                selectedKey={model.personaId}
                onChange={_onChangePersona}
                required
              />
            </div>
          </div>
        </div>

        <div className="ms-Grid-col ms-sm12 ms-lg12">
          <DetailsList
            items={itemsP}
            compact={true}
            columns={_columnsP}
            selectionMode={SelectionMode.none}
            setKey="single"
            layoutMode={DetailsListLayoutMode.fixedColumns}
            isHeaderVisible={true}
            selectionPreservedOnEmptyClick={true}
            enterModalSelectionOnTouch={true}
            ariaLabelForSelectionColumn="Toggle selection"
            ariaLabelForSelectAllCheckbox="Toggle selection for all items"
            checkButtonAriaLabel="select row"
          />
        </div>

        <Dialog
          hidden={hideDialog}
          onDismiss={toggleHideDialog}
          dialogContentProps={{
            title: "Enviando Información",
            type: DialogType.normal,
            subText: "Por favor espere un momento",
          }}
        >
          <ProgressIndicator barHeight={5} />
        </Dialog>

        <Dialog
          hidden={hideDialogSuccess}
          onDismiss={toggleHideDialogSuccess}
          dialogContentProps={{
            title: "Proceso Correcto",
            subText: "Su solicitud se procesó correctamente!",
          }}
        >
          <div style={{ width: "100%" }}>
            <div
              style={{
                width: "42px",
                height: "42px",
                margin: "0 auto",
              }}
            >
              <Icon
                iconName="Accept"
                style={{
                  color: theme.palette.themePrimary,
                }}
                className="ms-fontSize-42"
              ></Icon>
            </div>
          </div>

          <DialogFooter>
            <PrimaryButton onClick={() => {
              toggleHideDialogSuccess();
              setOpenPanel(false);
            }
            } text="Aceptar" />
          </DialogFooter>
        </Dialog>
        <Dialog
          hidden={hideDialogError}
          onDismiss={toggleHideDialogError}
          dialogContentProps={{
            title: "Error en Solicitud",
            subText: "Hubo un problema con la información enviada!",
          }}
        >
          <div style={{ width: "100%" }}>
            <div
              style={{
                width: "42px",
                height: "42px",
                margin: "0 auto",
              }}
            >
              <Icon
                iconName="ErrorBadge"
                style={{
                  color: theme.palette.redDark,
                }}
                className="ms-fontSize-42"
              ></Icon>
            </div>
          </div>

          <DialogFooter>
            <DefaultButton onClick={toggleHideDialogError} text="Aceptar" />
          </DialogFooter>
        </Dialog>
      </Panel>
    </div>
  );
}

export default ListarEquipoModelo;